import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { Guid } from 'guid-typescript';
import { TimeService } from 'src/app/services/time/time.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-message-page',
  templateUrl: './message-page.component.html',
  styleUrls: ['./message-page.component.css']
})

export class MessagePageComponent implements OnInit {

  //retrieved data
  data: Array<any> = [];
  languages: Array<any> = [];
  messageTypes: Array<string> = [];

  //filtered/displayed data
  filteredData: Array<any> = [];
  holidayData: Array<any> = [];

  //selector
  selectedLang: string = "DEFAULT";
  filterSelected: boolean = false;
  typeSelect: string = 'NoFilter';
  holidaySelect: any = "DEFAULT";

  //other
  formValid: boolean;
  lambdaError: boolean = false;
  lambdaMessage: string = '';
  showHolidaySelect: boolean = false;
  holidayError: boolean = false;
  holidayMessage: string = '';
  editOverWrite = null;                 //used to populate edited row with outside object
  currentUser: string = this.auth.currentUser;
  currentDay: string = this.timeService.wireFormatDate(new Date(), 0);
  currentYear: string = this.currentDay.split('-')[0];
  refreshDisabled: boolean = false;
  bluePrint = {
    'messageId': this.newMessageId(),
    'message': {
      'msgText': {
        'en-US': ""
      }, 
      'status': 'Enabled', 
      'messageType': ''
    },
    'messageDuration':{
      'messageStartTime': '00:00', 
      'messageEndTime': '23:59', 
      'messageStartDate': this.currentDay, 
      'messageEndDate': this.currentDay
    }, 
  };

  constructor(private telecomService: TelecomService, private timeService: TimeService, private auth: AuthService) { }

  ngOnInit() {
    this.telecomService.getLanguages().then((resultData:any)=>{
      console.log("get language result: ", resultData);
      this.languages = resultData.languages;
    });
    this.getData();
  }

  onTabChange(event){
    if(event.index === 1){
      this.getData();
    }
  }

  getData(){
    this.refreshDisabled = true;
    this.lambdaMessage = '';
    console.log("retrieving message data")
    //messages
    let messages = new Promise(resolve => {
      this.telecomService.getRows(environment.messagesLambdaName).then((response: any) => {
        if(response.statusCode == 200){
          this.data = response.body.message;
          if(this.data.length == 0){
            this.lambdaError = false;
            this.lambdaMessage += 'No data to display '
          }
          this.applyFilter();
        }else{
          this.lambdaError = true;
          this.lambdaMessage += response.Error.message;
          console.error(response); 
        }
        resolve(null);
      });
    })

    //types
    let types = new Promise(resolve => {
      this.telecomService.getRows(environment.getMessageTypesLambdaName).then((response: any) => {
        if(response.statusCode == 200){
          this.messageTypes = response.body.messageTypes.Item.data;
        }else{
          this.lambdaError = true;
          this.lambdaMessage += response.Error.message;
          console.error(response); 
        }
        resolve(null);
      });
    });

    //holidays
    let holidays = new Promise(resolve => {
      this.telecomService.getRows(environment.holidaysLambdaName).then((response: any) => {
        if(response.statusCode == 200){
          let temp = response.body.holidayList.Items;
          for(var x=0; x < temp.length; x++){
            if(temp[x]['Key'] == this.currentYear){
              this.holidayData = temp[x]['data'];
              for(let y = 0; y < this.holidayData.length; y++){
                if(this.holidayData[y].status == 'Disabled'){
                  this.holidayData.splice(y, 1);
                  y--;
                }
              }
              break;
            }
          }
          if(this.holidayData.length == 0){
            this.holidayError = false;
            this.holidayMessage = 'No holiday data for the current year.';
          }
        }else{
          this.lambdaError = true;
          this.lambdaMessage += response.Error.message;
          console.error(response); 
        }
        resolve(null);
      });
    });
    
    Promise.all([messages, types, holidays]).then(() => {
      console.log("message data retrieved");
      this.refreshDisabled = false;
    })
  }

  //save message changes
  updateItem(item: any){
    item.item.updatedBy = this.currentUser;
    this.updateLocalData(item.item)
    this.bluePrint.messageId = this.newMessageId();
    this.telecomService.saveRow(item, environment.messagesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.lambdaError = false;
        this.lambdaMessage = "Data saved successfully";
        if(item.action == 'put'){
          let index = this.data.findIndex(groupMessage => groupMessage.messageId == data.body.message.messageId);
          if(index != -1){
            let temp=JSON.parse(JSON.stringify(this.data));
            temp[index].lastUpdated = data.body.message.lastUpdated;
            this.data=temp;
          }
          this.applyFilter()
        }
      }else{
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.error(data.Error);
      }
    });

  }

  //populate new row with holiday info
  updateGridWithHolidayData(item: any, evt: any){
    if(evt != "DEFAULT"){
      console.log(evt);
      const obj = {
        'message': {
          'messageType': 'Holidays',
          'messageTitle': evt.holiday,
          'status': evt.status,
          'msgText': item.message.msgText
        },
        'messageDuration': {
          'messageStartDate': evt.startDate,
          'messageStartTime': evt.startTime,
          'messageEndDate': evt.endDate,
          'messageEndTime': evt.endTime
        }
      }
      this.editOverWrite = obj;
    }
  }

  //keep page data in sync with grid
  updateLocalData(item: any){
    var found = false;
    var temp = JSON.parse(JSON.stringify(this.data));
    for(var x = 0; x < this.data.length; x++){
      if(item['messageId'] == temp[x]['messageId']){
        temp[x] = item;
        found = true;
      }
    }
    if(!found){
      temp.unshift(item);
    }
    this.data = temp;
    this.applyFilter();
  }

  applyFilter(){
    this.filterSelected = true;
    if(this.typeSelect != null && this.typeSelect != 'NoFilter'){
      var temp = [];
      for(var i=0; i < this.data.length; i++){
        if(this.data[i]['message']['messageType'] == this.typeSelect){
          temp.push(this.data[i]);
        }
      }
      this.filteredData = temp;
    }else{
      this.filteredData = this.data;
    }
  }

  getLangByCode(code: string){
    for(var x = 0; x < this.languages.length; x++){
      if(this.languages[x][1] == code){
        return this.languages[x][0];
      }
    }
    return 'LanguageNotFound';
  }

  newMessageId(){
    return Guid.create()['value'];
  }

  addMessage(item: any){
    item.message.msgText[this.selectedLang] = "";
    this.selectedLang = "DEFAULT";
  }

  disableAddMessage(item: any){
    const keys = Object.keys(item.message.msgText);
    if(keys.includes(this.selectedLang)){
      return true;
    }
    return false;
  }

  deleteMessage(item: any, key: string){
    delete item.message.msgText[key];
    this.selectedLang = "DEFAULT";
  }

  handleHolidaySelect(type: string){
    if(type == 'Holidays'){
      this.holidaySelect = 'DEFAULT';
      if(this.holidayData.length == 0){
        this.lambdaError = this.holidayError;
        this.lambdaMessage = this.holidayMessage;
      }
    }
  }

  getMessageKeys(item: any){
    return Object.keys(item.message.msgText);
  }

  getAvailableLangs(item: any){
    const langKeys = Object.keys(item.message.msgText);
    var available = [];
    var found;
    for(var x=0; x < this.languages.length; x++){
      found = false;
      for(var y = 0; y < langKeys.length; y++){
        if(this.languages[x][1] == langKeys[y]){
          found = true;
        }
      }
      if(!found){
        available.push(this.languages[x]);
      }
    }
    return available
  }

  validate(item: any){
    this.formValid = false;
    this.lambdaMessage = '';

    if(!item.message.messageType || item.message.messageType == ''){
      this.lambdaMessage = 'Message Type is unselected';
      this.lambdaError = true;
      return;
    }
    if(!item.message.messageTitle || item.message.messageTitle == ""){
      this.lambdaMessage = 'The Title Field is empty';
      this.lambdaError = true;
      return;
    }
    var langKeys = Object.keys(item.message.msgText);
    if(langKeys.length == 0){
      this.lambdaMessage = 'There are no messages in the message field';
      this.lambdaError = true;
      return;
    }
    for(var key of langKeys){
      if(item.message.msgText[key] == ""){
        this.lambdaError = true;
        this.lambdaMessage = this.getLangByCode(key) + " message is missing text"
        return;
      }
    }

    
    if(item.messageDuration.messageStartDate == ''){
      this.lambdaMessage = 'Invalid start date';
      this.lambdaError = true;
      return;
    }

    if(item.messageDuration.messageEndDate == ''){
      this.lambdaMessage = 'Invalid end date';
      this.lambdaError = true;
      return;
    }


    var start = new Date(item.messageDuration.messageStartDate);
    start.setHours(this.timeService.getHoursFromString(item.messageDuration.messageStartTime), this.timeService.getMinutesFromString(item.messageDuration.messageStartTime));
    var end = new Date(item.messageDuration.messageEndDate);
    end.setHours(this.timeService.getHoursFromString(item.messageDuration.messageEndTime), this.timeService.getMinutesFromString(item.messageDuration.messageEndTime));

    if(start > end){
      this.lambdaMessage = 'End date/time must be after start date/time';
      this.lambdaError = true;
      return;
    }

    const min = new Date(new Date().getFullYear(), 0, 0, 0, 0, 0);
    const max = new Date(new Date().getFullYear(), 11, 31, 23, 59, 59);
    if((min > start) || (start > max)){
      this.lambdaMessage = 'Starting time must be in the current year';
      this.lambdaError = true;
      return;
    }

    this.formValid = true;
  }

}
